<template>
<div class="file-upload">
  <input
    class="file-upload__input"
    name="file"
    type="file"
    ref="inputFile"
    id="inputFile"
    @change="handleChange"
    accept="image/jpg, image/png, image/jpeg, video/mp4, video/x-m4v, video/quicktime, video/*">

    <label
      class="file-upload__label"
      for="inputFile">
      <img :src="upload" class="file-upload__label--icon"/>
      {{message}}
    </label>
</div>
</template>

<script>
import Upload from './../mixins/upload';
import uploadIcon from './../assets/images/upload-icon.png';

/**
 * ImageUpload
 *
 * file input for uploading an image
 */
export default {
  name: 'file-upload',
  mixins: [Upload],
  data() {
    return {
      message: 'Select a file to upload',
      upload: uploadIcon
    };
  }
};
</script>

<style lang="scss">
.file-upload {
  height: 100%;
  width: 100%;
  position: relative;
  &__label {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    font-size: $size-text-red-bull-body-copy-footnote;
    font-family: $font-family-upload;
    color: $color-text-file-upload-text;
    &--icon {
      color: $color-text-upload-icon;
      height: 25px;
      margin-bottom: 1.2rem;
    }
  }
  &__input {
    position: absolute;
    height: 0;
    width: 0;
    opacity: 0;
  }
}
</style>
